var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-badge',{attrs:{"value":_vm.goodsNumber,"hidden":_vm.goodsNumber <= 0}},[_c('div',{staticClass:"shop-cart",on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[(_vm.goodsNumber <= 0)?_c('i',{staticClass:"el-icon-shopping-cart-2"}):_c('i',{staticClass:"el-icon-shopping-cart-full"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }